<template>
    <div>
        <el-card class="prepaid-card">
            <div slot="header" class="card-header">
                预充值服务：课程抽点，将在产生订单后在预充值余额中扣除，退款将原路返回到此余额
            </div>

            <!-- 左侧数据展示 -->
            <el-row style="display: flex; align-items: center;">
                <el-col :span="6">
                    <div class="data-item">
                        <div class="data-label">当前余额</div>
                        <div class="data-value">{{ balanceData.surplus }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="data-item">
                        <div class="data-label">已消耗</div>
                        <div class="data-value">{{ balanceData.consumption }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="data-item">
                        <div class="data-label">
                            预估消耗
                            <el-tooltip content="预估消耗说明为已支付未结算订单产生的交易扣点" placement="top">
                                <i class="el-icon-question" style="margin-left: 5px;"></i>
                            </el-tooltip>
                        </div>
                        <div class="data-value">{{ balanceData.setting }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="data-item"
                        style="display: flex;flex-direction: column;justify-content: center;align-items: center; gap: 10px;">
                        <el-button type="primary" class="recharge-btn" @click="showRechargeDialog">充值</el-button>
                        <el-link href="#" class="link-item" @click.native.prevent="showFundDetailsDialog">资金明细</el-link>
                        <el-link href="#" class="link-item" @click.native.prevent="OpenBalanceWarningDialogVisible">余额预警</el-link>
                        <el-link href="#" class="link-item" @click.native.prevent="showRechargeLogDialog">充值记录</el-link>
                    </div>
                </el-col>
            </el-row>

        </el-card>

        <el-dialog title="支付详情" :visible.sync="rechargeDialogVisible" width="30%">
            <el-form label-width="100px">
                <el-form-item label="充值金额">
                    <el-input v-model="rechargeForm.amount" placeholder="请输入充值金额">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="充值说明">
                    <span style="color:red">请保证账户余额充足，避免因余额不足导致用户接收课程和短信失败。</span>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="rechargeDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleRechargeSubmit">前往充值</el-button>
            </span>
        </el-dialog>
        <el-dialog title="微信支付" :visible.sync="wechatDialogVisible" width="300px">
            <div style="text-align:center;padding:20px">
                <img :src="wechatDialogVisibleCode.wx_url"
                    style="width:200px;height:200px">
            </div>
        </el-dialog>
        <el-dialog title="资金明细" :visible.sync="fundDetailsDialogVisible" width="70%">
            <el-form label-width="100px" inline>
                <el-form-item label="订单号">
                    <el-input v-model="filterForm.order_no" placeholder="请输入订单号"></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker v-model="filterForm.dateRange" type="daterange" range-separator="-"
                        start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="订单状态">
                    <el-select v-model="filterForm.status" placeholder="请选择订单状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="已购买" value="4"></el-option>
                        <el-option label="已退款" value="7"></el-option>
                        <el-option label="待支付" value="2"></el-option>
                        <el-option label="退款中" value="9" class="refund"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryOrders">查询</el-button>
                    <el-button @click="resetFilters">重置</el-button>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="exportExcel">导出</el-button>

            <div style="width: 100%;">
                <el-table :data="orderInfo.list" style="width: 100%">
                    <el-table-column prop="index" label="序号">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_no" label="订单号" :width="'200px'">
                        <template slot-scope="scope">
                            {{ scope.row.order_no }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="deduct_money" label="扣点"></el-table-column>
                    <el-table-column prop="pay_amount" label="订单金额（元）"></el-table-column>
                    <el-table-column prop="income_status_desc" label="订单状态"></el-table-column>
                    <el-table-column prop="pay_time" label="创建时间" :width="'200px'">
                        <template slot-scope="scope">
                            {{ scope.row.pay_time }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog title="余额预警" :visible.sync="balanceWarningDialogVisible" width="600px">
            <el-form label-width="100px">
                <el-form-item label="设置余额">
                    <el-input v-model="amount" placeholder="请输入预警金额"></el-input>
                </el-form-item>
                <el-form-item label="预警方式">
                    <div>
                        温馨提示，"当前余额"≤"设置额度"，将发送短信通知给当前账号
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button @click="balanceWarningDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleBalanceWarningSubmit">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="充值记录" :visible.sync="rechargeLogDialogVisible" width="70%">
            <el-form label-width="100px" inline>
                <el-form-item label="时间范围">
                    <el-date-picker v-model="rechargeLogFilter.dateRange" type="daterange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryRechargeLogs">查询</el-button>
                    <el-button @click="resetRechargeLogFilters">重置</el-button>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="exportRechargeLogs">导出</el-button>

            <div style="width: 100%;">
                <el-table :data="rechargeLogData" style="width: 100%">
                    <el-table-column prop="index" label="序号">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="money" label="充值金额（元）"></el-table-column>
                    <el-table-column prop="payment_method" label="支付方式">
                        <template slot-scope="scope">
                            微信支付
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_time" label="创建时间"></el-table-column>
                </el-table>
            </div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="rechargeLogFilter.page"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="rechargeLogFilter.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="rechargeLogTotal">
            </el-pagination>
        </el-dialog>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';
import dayjs from 'dayjs';
import { sendPost } from '@/api/http.js';
import { getBaseUrl } from '@/utils/baseUrl.js'

export default {
    data() {
        return {
            rechargeDialogVisible: false,
            wechatDialogVisible: false,
            wechatDialogVisibleCode: '',
            rechargeForm: {
                amount: ''
            },
            fundDetailsDialogVisible: false,
            filterForm: {
                page: 1,
                page_size: 10,
                start_time: dayjs().subtract(6, 'day').format('YYYY-MM-DD 00:00:00'),
                end_time: dayjs().format('YYYY-MM-DD 23:59:59'),
                order_no: '',
                status: '',
                dateRange: [dayjs().subtract(6, 'day').toDate(), dayjs().toDate()]
            },
            balanceData: {
                surplus: '0.00',
                consumption: '0.00',
                warning_surplus: '0.00',
                setting: '0.00',
                author_id: null
            },
            balanceWarningDialogVisible: false,
            amount: '',
            amountCopy:'',
            rechargeLogDialogVisible: false,
            rechargeLogFilter: {
                page: 1,
                page_size: 10,
                dateRange: [],
            },
            rechargeLogData: [],
            rechargeLogTotal: 0,
        };
    },
    computed: {
        ...mapState('order', ['orderInfo']),
    },
    watch: {
        orderInfo: {
            handler(newVal) {
                console.log('预充值',newVal);
                
            },
            deep: true,
            immediate: true
        },
        'filterForm.dateRange': {
            handler(newVal) {
                if (newVal) {
                    this.filterForm.start_time = dayjs(newVal[0]).format('YYYY-MM-DD 00:00:00');
                    this.filterForm.end_time = dayjs(newVal[1]).format('YYYY-MM-DD 23:59:59');
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('order', ['getOrderInfo']),

        async handleBalanceWarningSubmit() {
            const response = await sendPost('user/user/prepay/warring',{
                money: this.amount,
            });
            console.log('预充值',response);
            this.$message.success('设置成功');
            this.amountCopy = this.amount;
            this.balanceWarningDialogVisible = false;
            this.amount = '';
        },
        OpenBalanceWarningDialogVisible(){
            this.amount = this.amountCopy;
            this.balanceWarningDialogVisible = true;
        },
        showRechargeDialog() {
            this.rechargeDialogVisible = true;
        },
        async handleRechargeSubmit() {
            this.rechargeDialogVisible = false;
            const response = await sendPost('user/user/prepay/recharge',{
                price: this.rechargeForm.amount,
            });
            console.log('预充值',response);
            this.wechatDialogVisible = true;
            this.wechatDialogVisibleCode = response;
            // 充值后自动开始轮询订单状态
            this.pollOrderStatus();
        },
        //检查订单是否支付成功
        async checkOrderStatus() {
            const response = await sendPost('user/user/prepay/check/order',{
                out_trade_no: this.wechatDialogVisibleCode.out_order_no,
            });
            console.log('预充值',response);
            return response;
        },
        // 轮询订单状态
        pollOrderStatus() {
            let count = 0;
            const maxCount = 100;
            const interval = 3000; // 3秒
            if (this._orderStatusTimer) {
                clearTimeout(this._orderStatusTimer);
            }
            const poll = async () => {
                count++;
                const res = await this.checkOrderStatus();
                console.log('预充值',res);
                if (res && res.notify_status === 1) {
                    this.$message.success('支付成功！');
                    this.wechatDialogVisible = false;
                    this.fetchBalanceData()
                    return;
                }
                if (count >= maxCount) {
                    this.$message.warning('支付超时，请重新发起支付！');
                    this.wechatDialogVisible = false;
                    return;
                }
                this._orderStatusTimer = setTimeout(poll, interval);
            };
            poll();
        },
        showFundDetailsDialog() {
            this.fundDetailsDialogVisible = true;
            this.getpreRecharge(true);
        },
        queryOrders() {
            this.getpreRecharge(true);
        },
        resetFilters() {
            this.filterForm = {
                page: 1,
                page_size: 10,
                start_time: dayjs().subtract(6, 'day').format('YYYY-MM-DD 00:00:00'),
                end_time: dayjs().format('YYYY-MM-DD 23:59:59'),
                order_no: '',
                status: '',
                dateRange: [dayjs().subtract(6, 'day').toDate(), dayjs().toDate()]
            };
        },
        exportExcel() {
           
            this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '导出',
                cancelButtonText: '取消',
                customClass: ''
            })
            .then(async() => {
                await sendPost('user/export/create', {
                    type: 13, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单
                    search_params: {
                        ...this.filterForm,
                        excel: 1,
                        comeFrom: 2,
                        deduct_money: this.deduct_money // 确保处理deduct_money字段
                    }
                })
                this.$router.push({
                    path:  this.staticPath + "exportHistory"
                })
            })
        },
        async getpreRecharge(flag) {
            if(flag) {
                this.filterForm.page = 1;
            }
            this.getOrderInfo(this.filterForm);
        },
        async fetchBalanceData() {
            try {
                const response = await sendPost('user/user/prepay');
                console.log('预充值',response);
                this.balanceData = response;
                this.amountCopy =Number(response.warning_surplus) !== 'NaN'  ? Number(response.warning_surplus) : 0;
            } catch (error) {
                this.$message.error('请求失败');
            }
        },
        showRechargeLogDialog() {
            this.rechargeLogDialogVisible = true;
            this.queryRechargeLogs();
        },
        async queryRechargeLogs() {
            const [start, end] = this.rechargeLogFilter.dateRange || [];
            const response = await sendPost('user/user/prepay/log', {
                created_time_start: start ? dayjs(start).format('YYYY-MM-DD 00:00:00') : '',
                created_time_end: end ? dayjs(end).format('YYYY-MM-DD 23:59:59') : '',
                is_export: false,
            });
            this.rechargeLogData = response.data;
            this.rechargeLogTotal = response.total;
        },
        resetRechargeLogFilters() {
            this.rechargeLogFilter = {
                page: 1,
                page_size: 10,
                dateRange: [],
            };
            this.queryRechargeLogs();
        },
        async exportRechargeLogs() {
            let getToken = localStorage.getItem('token');
            const params = {
                created_time_start: this.rechargeLogFilter.dateRange[0] ? dayjs(this.rechargeLogFilter.dateRange[0]).format('YYYY-MM-DD 00:00:00') : '',
                created_time_end: this.rechargeLogFilter.dateRange[1] ? dayjs(this.rechargeLogFilter.dateRange[1]).format('YYYY-MM-DD 23:59:59') : '',
                excel: true,
                token: getToken,
            };
            await sendPost('user/user/prepay/log', { ...params }, 'get',undefined, {}, {
                responseType: 'blob' // 关键配置
            }).then((res)=>{
                const blob = new Blob([res.data]);
                // 创建临时链接
                const downloadUrl = window.URL.createObjectURL(blob);

                // 创建 <a> 标签并模拟点击
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '充值记录.xlsx'); // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                // 清理内存中的对象 URL
                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(link);
                 this.$message.success('导出成功');
               
            })
        },
        
        handleSizeChange(val) {
            this.rechargeLogFilter.page_size = val;
            this.queryRechargeLogs();
        },
        handleCurrentChange(val) {
            this.rechargeLogFilter.page = val;
            this.queryRechargeLogs();
        },
    },
    mounted() {
        this.fetchBalanceData();
    }
}
</script>

<style scoped>
.prepaid-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    ::v-deep .el-card__body {
        padding: 0;
    }
}

.card-header {
    font-size: 14px;
    color: #606266;
    font-weight: normal;
}

.data-item {
    text-align: center;
    padding: 15px 0;
}

.data-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 5px;
}

.data-value {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}

.right-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding: 20px;
}

.mode-switcher {
    width: 100%;
    height: 40px;
    background-color: #f5f5f5;
    margin-bottom: 15px;
}

.recharge-btn {
    width: 120px;
}

.bottom-links {
    margin-top: 15px;
    text-align: right;
}

.link-item {
    margin-left: 20px;
    color: #409EFF;
}
</style>